import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PositionRole } from 'src/app/models/position-role.model';
import { PositionUserRequest } from 'src/app/models/user.model';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class RolesAndPermissionsService {
	private url = environment.api;
	constructor(private http: HttpClient) { }

	getUrlApi() {
		return this.url;
	}

	getPermissions(companyId: number) {
		return this.http.get(this.url + 'api/role/allRoles');
	}

	getUserRoles() {
		return this.http.get(this.url + 'api/role/v2/user');
	}

	getPositions() {
		return this.http.get(this.url + "api/erp/payroll/organization/allPositions");
	}

	/**
	 * Obtains all areas
	 * @returns a json with the follow structure {data:Area[],message,success:true}
	 */
	getAreas() {
		return this.http.get(this.url + "api/erp/payroll/organization/allAreas");
	}

	/**
	 * Obtains all departments
	 * @returns a json with the follow structure {data:Department[],message,success:true}
	 */
	getDepartments() {
		return this.http.get(this.url + "api/erp/payroll/organization/allDepartments");
	}

	savePositionRole(newPositionRole: PositionRole, isPartner = false) {
		return this.http.post(this.url + "api/erp/posRole/save" + (isPartner ? 'Admin' : ''), newPositionRole);
	}

	getRolePermissions(clue: number) {
		return this.http.get(this.url + "api/erp/posRole/all", {
			params: {
				clue: clue
			}
		});
	}

	getRoleAdminPermissions(clue: number) {
		return this.http.get(this.url + "api/erp/posRole/allAdmin", {
			params: {
				clue: clue
			}
		});
	}

	getDepartmentsByArea(idArea: number) {
		return this.http.get(this.url + "api/erp/payroll/organization/departments?area=" + idArea);
	}

	updatePositionRole(updatedPositionRole: PositionRole) {
		return this.http.put(this.url + "api/erp/posRole/update", updatedPositionRole);
	}

	getDepartmentPositions(department_id: number) {
		return this.http.get(this.url + "api/erp/payroll/organization/positions?department=" + department_id);
	}

	getUsers(companyId) {
		return this.http.get(this.url + "api/role/children/" + companyId + "/" + 20);
	}

	getUsersAdmin(companyId) {
		return this.http.get(this.url + "api/role/childrenAdmin/" + companyId + "/" + 20);
	}

	saveUserPosition(newUserPosition: PositionUserRequest) {
		return this.http.post(this.url + "api/erp/userPosition/save", newUserPosition);
	}

	editUserPosition(newUserPosition: PositionUserRequest) {
		return this.http.put(this.url + "api/erp/userPosition/update", newUserPosition);
	}

	deleteUserPosition(userId: number) {
		return this.http.delete(this.url + `api/erp/userPosition/delete/${userId}`);
	}

	getUserPosition(clue: string) {
		return this.http.get(this.url + "api/erp/userPosition/all", {
			params: {
				clue: clue
			}
		});
	}

	checkEmail(email: string, company: number) {
		return this.http.get(this.url + 'api/user/checkSerp', {
			params: {
				email: email,
				company: company
			}
		})
	}

	deactivatePartner(email: string) {
		return this.http.post(this.url + 'api/user/deactivatepartner/' + email, null)
	}

	deactivateUserPartner(email: string) {
		return this.http.post(this.url + 'api/user/deactivateuserpartner/' + email, null)
	}

	saveUserOnOldTable(newUser: any) {
		return this.http.post(this.url + "api/role/company/grant/roles", newUser);
	}


}
